import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {FaCamera, FaCog, FaDownload, FaTrash} from "react-icons/fa";
import {MdOutlineRefresh} from "react-icons/md";
import {downloadCSV} from "../../../../../service/downloadCSV";
import {formatCSV} from "../../../../../service/formatCSV";
import Popover from "../../../../Popover";
import PopoverItem from "../../../../Popover/PopoverItem";

const CellContext = (props) => {
  const {
    downloadScreenshot = () => {},
    filename = "new-file",
    getData,
    isHidden = false,
    onDelete = () => {},
    onRefresh = () => {},
    showDelete = false,
  } = props;

  const handleCSVDownload = async () => {
    let downloadData = "No Data Available";
    if (getData) {
      const csvData = await getData("csv", false);
      if (csvData) {
        downloadData = formatCSV(csvData);
      }
    }
    downloadCSV(downloadData, filename);
  };

  if (!isHidden) {
    return (
      <div style={{marginRight: "10px"}}>
        <Popover icon={FaCog} position={"bottom right"} contentZIndex={1065}>
          <PopoverItem
            label={"Refresh"}
            icon={MdOutlineRefresh}
            onContentSelection={onRefresh}
          />
          <PopoverItem
            label={"Take screenshot"}
            icon={FaCamera}
            onContentSelection={downloadScreenshot}
          />
          <PopoverItem
            label={"Download_CSV"}
            icon={FaDownload}
            onContentSelection={handleCSVDownload}
          />
          {showDelete && (
            <PopoverItem label={"Delete"} icon={FaTrash} onContentSelection={onDelete} />
          )}
        </Popover>
      </div>
    );
  }
  return <Fragment></Fragment>;
};

CellContext.propTypes = {
  /** function to get data */
  getData: PropTypes.func,
  /** Callback function which will be executed on click of Take screenshot */
  downloadScreenshot: PropTypes.func,
  /** Name of file to be downloaded */
  filename: PropTypes.string,
  /** Flag to hide the context menu */
  isHidden: PropTypes.bool,
  /** Callback function which will be executed on click of Delete */
  onDelete: PropTypes.func,
  /** Callback function which will be executed on click of Refresh */
  onRefresh: PropTypes.func,
  /** Flag to show delete option */
  showDelete: PropTypes.bool,
};

export default CellContext;
